import { useTheme } from 'next-themes';
import { useEffect, useMemo, useState } from 'react';
import { toast } from 'sonner';
import { useSession } from '@/contexts/LitSessionProvider';
import { baseUrl } from '@/lib/misc/const';
import usePaymentProvider from '@/hooks/deposit/usePaymentProvider';
import useAppSettings, { AppConfigKeys, MoonpayMappings } from '@/hooks/admin/useAppSettings';
import useGetLocation from '@/hooks/utilities/useGetLocation';
import useAppDetails from '@/hooks/utilities/useAppDetails';
export default function useMoonpayUrl({
  amount
}) {
  var _a;
  const {
    PKP
  } = useSession();
  const {
    resolvedTheme: theme
  } = useTheme();
  const {
    selectedPaymentMethod
  } = usePaymentProvider();
  const [signedUrl, setSignedUrl] = useState(null);
  const [loading, setLoading] = useState(true);
  const {
    appConfig
  } = useAppSettings();
  const {
    geoCountry
  } = useGetLocation();
  const {
    depositCurrencyOverride
  } = useAppDetails();
  const currencyKey = depositCurrencyOverride || appConfig[AppConfigKeys.onboardingCurrency];
  const moonpayMethod = useMemo(() => {
    if (selectedPaymentMethod == 'card') return 'credit_debit_card';
    if (selectedPaymentMethod == 'bank') return 'ach_bank_transfer';
    if (selectedPaymentMethod == 'apple') return 'mobile_wallet';
    if (selectedPaymentMethod == 'google') return 'mobile_wallet';
  }, [selectedPaymentMethod, currencyKey]);
  const mpSdk = {
    version: '1.9.6',
    environment: 'production',
    flow: 'buy',
    variant: 'newWindow',
    platform: 'web'
  };
  const restrictedBnB = geoCountry == 'US' || geoCountry == 'CA' || geoCountry == 'GB' && MoonpayMappings[currencyKey] == 'bnb_bsc';
  const apiKey = 'pk_live_xn7Rp2sWBEOOyTjsoTKNtjeYX68CzXd';
  const currencyCode = restrictedBnB ? MoonpayMappings['SOL'] : MoonpayMappings[currencyKey] || MoonpayMappings['SOL'];
  const walletAddress = ((_a = currencyCode === null || currencyCode === void 0 ? void 0 : currencyCode.toLowerCase()) === null || _a === void 0 ? void 0 : _a.includes('sol')) ? PKP === null || PKP === void 0 ? void 0 : PKP.solanaAddress : PKP.additionalEthAddress;
  const preMoonpayUrl = `https://buy.moonpay.com/?apiKey=${apiKey}&currencyCode=${currencyCode}&defaultCurrencyCode=${currencyCode}&walletAddress=${walletAddress}&theme=${theme}&baseCurrencyCode=USD&baseCurrencyAmount=${amount}&paymentMethod=${moonpayMethod}&showAllCurrencies=false&mpSdk=${encodeURIComponent(JSON.stringify(mpSdk))}`;
  const handleGetSignature = async url => {
    setLoading(true);
    console.log('moonpay url', url, currencyKey, currencyCode);
    try {
      const signature = await fetch(`${baseUrl}/api/moonpay`, {
        method: 'POST',
        body: JSON.stringify({
          url
        }),
        headers: {
          'Content-Type': 'application/json'
        }
      });
      const data = await signature.json();
      const encodedSignature = encodeURIComponent(data.url);
      const fullUrl = preMoonpayUrl + `&signature=${encodedSignature}`;
      setSignedUrl(fullUrl);
      return data.url;
    } catch (_) {
      toast.error('We had an error initiating your deposit, please try again');
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    handleGetSignature(preMoonpayUrl);
  }, [amount, currencyKey]);
  return {
    signedUrl,
    loading
  };
}